import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import axios from "axios";

// The navbar's way to the customer's bundles, with how many notifications they have
// not seen (utils/notify.js on the backend): a refund of pages, a friend who joined.
// The navbar stays up from page to page, so it asks again on each one: leaving
// /my-bundles, which marks them read, clears the count.
const NavBundles = () => {
  const { pathname } = useLocation();
  const [unread, setUnread] = useState(0);

  useEffect(() => {
    let live = true;
    axios
      .get("/api/bundles/notifications")
      .then((res) => {
        if (live) setUnread(res.data.unread || 0);
      })
      .catch(() => {});
    return () => {
      live = false;
    };
  }, [pathname]);

  return (
    <Link to="/my-bundles" className="navbar-item bnd-nav">
      <span className="button signup-button bnd-nav-button">
        <i className="fas fa-layer-group" aria-hidden="true"></i>
        <span>Багц</span>
        {unread > 0 && (
          <span className="bnd-nav-badge" aria-label={unread + " шинэ мэдэгдэл"}>
            {unread > 9 ? "9+" : unread}
          </span>
        )}
      </span>
    </Link>
  );
};

export default NavBundles;
